// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-generic-template-js": () => import("/Users/candrews/Documents/Middlebury/courses/cs312/current/cs312-f19-web/src/templates/genericTemplate.js" /* webpackChunkName: "component---src-templates-generic-template-js" */),
  "component---src-templates-assignment-template-js": () => import("/Users/candrews/Documents/Middlebury/courses/cs312/current/cs312-f19-web/src/templates/assignmentTemplate.js" /* webpackChunkName: "component---src-templates-assignment-template-js" */),
  "component---src-pages-404-js": () => import("/Users/candrews/Documents/Middlebury/courses/cs312/current/cs312-f19-web/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

